import { toast } from '@stores/toastStore'

import { scopedTranslation } from '@utils/I18n'

import { AssignShiftSlotDocument } from '@frontend/graphql/mutations/assignShiftSlot.generated'

import { useRosterActionMutation } from '../roster_board/useRosterActionMutation'

const t = scopedTranslation('components.assign_shift')

type AssignShiftSlotInput = {
  id: string
  supporterId: string
  onSuccess: () => void
  onError?: () => void
}

const useAssignShiftSlotMutation = () => {
  const { run, isPending } = useRosterActionMutation({
    document: AssignShiftSlotDocument,
    succeeded: (response) => Boolean(response?.assignShiftSlot?.shiftSlot),
    errorCode: 'ASSIGN_SHIFT_ERROR',
    failureMessage: t('errors.unable_to_submit_shift_error'),
    extractErrors: (response) => response?.assignShiftSlot?.errors,
    interceptErrors: (errors) => {
      const duplicate = errors.find((error) => error.code === 'already_assigned_to_shift')
      if (!duplicate) return false

      toast.warning(duplicate.message)
      return true
    },
  })

  return {
    assignShiftSlot: ({ id, supporterId, onSuccess, onError }: AssignShiftSlotInput) =>
      run({ id: String(id), supporterId, onSuccess, onError }),
    isPending,
  }
}

export default useAssignShiftSlotMutation
